'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationButtonController = function () {
    function WinresReservationButtonController($rootScope, $scope, $document) {
        _classCallCheck(this, WinresReservationButtonController);

        this.$document = $document;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
    }

    _createClass(WinresReservationButtonController, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'click',
        value: function click() {
            var phase = this.winresReservationContext.getCurrentPhase();
            var errors = this.winresReservationContext.getPhaseErrors(phase);
            if (phase == 'passenger') errors = errors.concat(this.winresReservationContext.getPhaseErrors('customer'));
            if (errors.length > 0) {
                this.winresReservationContext.showSpecificErrors(errors);
                //this.winresReservationContext.showBasketPopup = 'visible';
                var elem = angular.element('#shopping-tabs-anchor');
                if (elem.length) {
                    this.$document.scrollToElement(elem, 0, 100);
                }
            } else if (this.isPayButton === 'true') {
                // Go to payment or show errors.
                this.$rootScope.$broadcast('clickPayButton');
            } else {
                this.winresReservationContext.goToNextPhase();
            }
        }
    }]);

    return WinresReservationButtonController;
}();

WinresReservationButtonController.$inject = ['$rootScope', '$scope', '$document'];

_module3.default.component('winresReservationButton', {
    template: require('./winresReservationButton.html'),
    controller: WinresReservationButtonController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        language: '@',
        showErrorGroup: '@', // shows errors from specific locale-group, ie. all reservation_passenger.xxxxxx errors. If null, errors won't be displayed. Add also to winresReservationPassengerInfo.js
        isPayButton: '@' // If should continue to payment.
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationButton/winresReservationButton.js
// module id = 406
// module chunks = 2